import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-6 z-40 transition-all duration-500 ease-out ${
        visible
          ? "translate-y-0 opacity-100"
          : "translate-y-16 opacity-0 pointer-events-none"
      }`}
    >
      <Link
        to="/intake"
        className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3.5 rounded-full text-base font-semibold hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
      >
        Start your journey now
        <span className="w-5 h-5 inline-flex items-center justify-center">
          <i className="ri-arrow-right-line"></i>
        </span>
      </Link>
    </div>
  );
}
